module.exports = {
	"addDetail": "Add detail about lot",
	"linkInfo": "Edit lot informations",
	"noDetails": "No details about this lot provided.",
	"lotLimit": "You have now reached the maximum amount of lots allowed per auction with your current subscription, which is __lotLimit__.",
	"pictureLimit": "You have now reached the maximum amount of pictures allowed per lot with your current subscription, which is __pictureLimit__.",
	"lotCreate": {
		"header": "Create lot",
		"descriptionLabel": "Short Description",
		"lotCreated": "Lot __rank__ - __name__ added to auction.",
		"lotPicturesLabel": "Pictures",
		"namePlaceholder": "Lot name"
	},
	"cancel": {
		"cancel": "Cancel lot",
		"confirm": "Are you sure you want to cancel the lot? You will lose all bids made by participants thus far. $t(general::cannotUndo)",
		"success": "Your lot was successfully cancelled! Participants will be notified."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/oa-lot.json5
// module id = 1945
// module chunks = 6